<script>
import { CARD_ART_HEIGHT } from '../ui/art';

export default {
  name: 'ArtPending',
  data() {
    return {
      CARD_ART_HEIGHT
    };
  }
};
</script>

<template>
  <img src="/add-to-transcript/art-pending.gif" :height="CARD_ART_HEIGHT" />
</template>
